module.exports = __webpack_public_path__ + "static/media/sonicare_icon.6bcfba07.png";